<div class="form-field">
    <p class="field-name">
        {{ model.fieldName }}
        @if(model.isMandatory) {
        <span class="imp">*</span>
        }
    </p>

    <div [class.disclosure]="model.fieldValue === 'data_accuracy_declaration'">
        @if (model.fieldDescription && model.fieldDescription.length && model.fieldType != 'none' && model.fieldValue
        ===
        "data_accuracy_declaration") {
        <ng-container *ngTemplateOutlet="description"></ng-container>
        }

        @switch (model.fieldType) {
        @case ("none") {
        <span>
            <p>{{model.fieldDescription}}</p>
        </span>
        }

        @case ("paragraph") {
        <span class="paragraph">
            <div class="paragraph-content">@if (model.resolvedLines?.length) {@for (line of model.resolvedLines; track $index) {<p class="paragraph-line">@for (segment of line; track $index) {<span [class.paragraph-value]="segment.kind === 'value'" [class.paragraph-blank]="segment.kind === 'blank'">{{ segment.text }}</span>}</p>}} @else {<p class="paragraph-line">{{ model.fieldDescription }}</p>}</div>
        </span>
        }

        @case ("email") {
        <span [class]="model.fieldType">
            <div class="email-group">
                <input [id]="model.fieldId" type="email" pInputText
                    [readOnly]="((emailVerified && !editMode) && (model.fieldValue === 'email_id' || model.fieldValue === 'confirm_email_id')) || preview"
                    [placeholder]="model.placeHolder" [(ngModel)]="model.answer[0]" (ngModelChange)="onEmailChange()"
                    [disabled]="(model.disabled ?? false) || (model.section_label?.toLowerCase() === 'custom fields' && !emailVerified)"
                    [required]="model.isMandatory" [class.disable-input-field]="model.disabled ?? false"
                    (blur)="onBlur()"
                    [class.has-verify-email]="model.fieldValue === 'confirm_email_id' && !emailVerified"
                    [autocomplete]="'new-password'"
                    [class.is-invalid]="(touched && !model.disabled && !model.isValid && !preview) || (touched && model.fieldValue === 'confirm_email_id' && model.isValid && !duplicateData.emailDuplicate && !preview)" />
                @if (model.fieldValue === "confirm_email_id") {
                <div class="verifyOtp">
                    @if (!emailVerified && !editMode) {
                    <p-button styleClass="p-button-sm" class="verify-btn"
                        (click)="duplicateData.emailDuplicate && model.isValid && !verifyingEmail ? verifyEmail() : null"
                        [ngStyle]="{'pointer-events': (model.isValid ? 'auto' : 'none') }"
                        [disabled]="!duplicateData.emailDuplicate || !model.isValid || verifyingEmail">
                        <img alt="Verify" src="../../../assets/verify-symbol-white.png"
                            style="width: 18px; margin-right: 8px;" />
                        <span class="ml-2 font-bold">Verify </span>
                    </p-button>
                    }
                    @if (emailVerified && !editMode) {
                    <div class="verified">
                        <span>Verified</span>
                        <img src="../../../assets/verifed-symbol.png" alt="Verified" style="width: 16px; height: 16px;">
                    </div>
                    }
                </div>
                }
            </div>
            @if (touched && !model.disabled && !model.isValid && !preview && !duplicateData.secondaryEmailIdSame) {
            <span class="error-message">Please enter valid email.</span>
            }
            @if (touched && model.fieldValue === "confirm_email_id" && model.isValid && !duplicateData.emailDuplicate &&
            !preview) {
            <span class="error-message">Email Id does not match.</span>
            }
            @if (touched && !model.isValid && duplicateData.secondaryEmailIdSame) {
            <span class="error-message">Primary & Secondary Email cannot be same.</span>
            }
        </span>
        }

        @case ("input") {
        <span [class]="model.fieldType">
            <input pInputText [id]="model.fieldId" [placeholder]="model.placeHolder"
                [type]="model.fieldValue == 'aadhar_card' ? 'number' : 'text'"
                [class.disable-input-field]="model.disabled ?? false" [readOnly]="model.readOnly || preview"
                [disabled]="model.disabled || !emailVerified" [(ngModel)]="model.answer[0]"
                [required]="model.isMandatory" (ngModelChange)="onInputChange()" (blur)="onBlur()"
                [class.is-invalid]="touched && !model.disabled && !model.isValid && !preview" />
            @if (touched && !model.disabled && !model.isValid && !preview) {
            <span class="error-message">Please enter valid data.</span>
            }
        </span>
        }

        @case("number") {
        <span [class]="model.fieldType">
            <input type="number" [readOnly]="model.readOnly || preview" [disabled]="model.disabled || !emailVerified"
                [class.disable-input-field]="model.disabled ?? false" [placeholder]="model.placeHolder"
                [(ngModel)]="model.answer[0]" [id]="model.fieldId" pInputText (keydown)="preventEAndMinus($event)"
                (keypress)="((model.fieldValue == 'aadhar_card' || model.fieldName == 'Pin Code') ? restrictNumber($event, model.fieldValue == 'aadhar_card' ? 12 : model.fieldName == 'Pin Code' ? 6 : 0) : model.fieldName == 'Reason for declining the offer' ? restrictCharacters($event, 50) : null)"
                (paste)="(model.fieldValue == 'aadhar_card' || model.fieldName == 'Pin Code') ? restrictNumber($event, model.fieldValue == 'aadhar_card' ? 12 : model.fieldName == 'Pin Code' ? 6 : 0) : model.fieldName == 'Reason for declining the offer' ? restrictCharacters($event, 50) : null"
                (ngModelChange)="onNumberChange()" (blur)="onBlur()" (paste)="onpaste($event)"
                [class.is-invalid]="touched && !model.disabled && !model.isValid && !preview" [min]="0" />
            @if (touched && !model.disabled && !model.isValid && !preview && !cgpaError) {
            <span class="error-message">Please enter valid data.</span>
            }
            @if (cgpaError && !preview) {
            <span class="error-message">{{ cgpaError }}</span>
            }
        </span>
        }

        @case ("dropdown") {
        <span [class]="model.fieldType" [class.disabled]="model.disabled || !emailVerified">
            <p-autoComplete #auto [suggestions]="model.fieldOptions" [dropdown]="true" [id]="model.fieldId"
                [placeholder]="model.placeHolder" optionLabel="label" [required]="model.isMandatory"
                [disabled]="model.disabled || !emailVerified" [readonly]="model.readOnly || preview"
                appendTo="body"
                [overlayOptions]="{styleClass: fromFeedback ? 'dropdown-form-field overflow-auto overflow-normal' : 'overflow-auto overflow-normal'}" [(ngModel)]="model.answer[0]"
                (onSelect)="onDropdownChange(auto)" [forceSelection]="true"
                (onShow)="onDropdownShow($event)" (onHide)="onDropdownHide($event)" [minLength]="0"
                [completeOnFocus]="!preventDropdownAutoOpen" (completeMethod)="filterOption($event)"
                (click)="onDropdownClick(auto)" (blur)="onBlur()" [showEmptyMessage]="true"
                [emptyMessage]="loadingInstitutions ? 'Searching...' : 'No results found'"
                [class.is-invalid]="touched && !model.disabled && !model.isValid && !preview && !needToShowOtherCollegeDetails()"
                [panelStyle]="{
                    'min-width': auto.el.nativeElement.offsetWidth + 'px',
                    'max-width': auto.el.nativeElement.offsetWidth + 'px'
                }">
                <ng-template pTemplate="loadingicon"></ng-template>
            </p-autoComplete>
            <!-- <p-select [id]="model.fieldId" [options]="model.fieldOptions" [autoDisplayFirst]="false"
                [placeholder]="model.placeHolder" optionLabel="label" [required]="model.isMandatory" filterBy="label"
                [filter]="model.fieldOptions.length > 1" [(ngModel)]="model.answer[0]"
                [readonly]="model.readOnly || preview" [disabled]="model.disabled || !emailVerified"
                (ngModelChange)="onDropdownChange()" (blur)="onBlur()">
            </p-select> -->
            @if (touched && !model.disabled && !model.isValid && !preview && !needToShowOtherCollegeDetails()) {
            <span class="error-message">Please select valid data.</span>
            }
        </span>
        }

        @case ("percentage") {
        <span>
            <span class="p-input-icon-right">
                <p-inputNumber [(ngModel)]="model.answer[0]" [id]="model.fieldId" mode="decimal" [min]="0.00"
                    [minFractionDigits]="2" [maxFractionDigits]="2" [step]="0.01" [useGrouping]="false"
                    (ngModelChange)="onPercentageChange()" [required]="model.isMandatory"
                    [class.disable-input-field]="model.disabled"
                    [class.is-invalid]="touched && !model.isValid && !model.disabled && !preview"
                    [disabled]="preview || (model.disabled ?? false) || !emailVerified" (blur)="onBlur()">
                </p-inputNumber>
                <i class="pi pi-percentage"></i>
            </span>
            @if (touched && !model.isValid && !model.disabled && !preview && !percentageError) {
            <span class="error-message">Please enter valid data.</span>
            }
            @if (percentageError && !preview) {
            <span class="error-message">{{ percentageError }}</span>
            }
        </span>
        }

        @case ("radio") {
        <span [class]="model.fieldType">
            @for (option of model.fieldOptions; track $index) {
            <div [class]="'field-' + model.fieldType">
                <p-radioButton [id]="model.fieldId" [inputId]="model.fieldId + option.value" [name]="model.fieldValue"
                    [value]="option.value" [(ngModel)]="model.answer[0]" (ngModelChange)="onRadioChange()"
                    [required]="model.isMandatory" [class.disable-input-field]="model.disabled"
                    [disabled]="preview || (model.disabled ?? false) || !emailVerified" (blur)="onBlur()">
                </p-radioButton>
                <label [class.disable-input-field]="model.disabled" [for]="model.fieldId + option.value">
                    {{ option.label}}
                </label>
            </div>
            }
            @if (touched && !model.isValid && model.isMandatory) {
            <span class="error-message">This field is required!</span>
            }
        </span>
        }

        @case ("date picker") {
        <span [class]="model.fieldType" style="display: inline-flex; flex-direction: column; margin: 1vh 0; width: 100%;">
            <p-datepicker iconDisplay="input" [id]="model.fieldId" dateFormat="mm-dd-yy" dataType="string"
                inputId="dateformat" [(ngModel)]="model.answer[0]" (ngModelChange)="onDateChanged()"
                [minDate]="currentDate" [required]="model.isMandatory"
                [disabled]="preview || (model.disabled ?? false) || !emailVerified" (blur)="onBlur()"
                [panelStyle]="{
                    'min-width': 'auto',
                    'width': 'auto'
                }"
                [class.is-invalid]="(touched && !model.isValid && model.isMandatory) || (belowAge)">
            </p-datepicker>
            @if (touched && !model.isValid && model.isMandatory && !belowAge) {
            <span class="error-message">This field is required!</span>
            }
            @if (belowAge) {
            <span class="error-message">Candidate must be 18 years old or above!</span>
            }
        </span>
        }

        @case ("mobile") {
        <span [class]="model.fieldType">
            <div class="mobile-group">
                <div class="p-inputgroup mobile-container">
                    <p-inputGroup>
                        <p-select [options]="_countryCodeList" [(ngModel)]="selectedCode" optionLabel="country"
                            [filter]="true" placeholder="+Code" class="country-selection"
                            [panelStyle]="{width: '250px !important'}" filterPlaceholder="Search Country"
                            [disabled]="!emailVerified || preview || (model.disabled ?? false)">
                            <ng-template pTemplate="item" let-code>
                                <p (click)="selectedCode = code; onMobileChange()">
                                    {{code.country}} <span [style]="{fontWeight: '600'}">
                                        (+{{code.countryCodes[0]}})</span> </p>
                            </ng-template>

                            <ng-template pTemplate="selectedItem">
                                <p>
                                    {{selectedCode.country}}
                                    <span [style]="{fontWeight: '600'}">
                                        (+{{selectedCode.countryCodes}})
                                    </span>
                                </p>
                            </ng-template>
                        </p-select>

                        <input class="mobile-input-field" type="tel" [id]="model.fieldId"
                            [readonly]="model.readOnly || mobileVerified"
                            (click)="duplicateData.mobileDuplicate = false" [(ngModel)]="model.answer[1]"
                            [maxlength]="selectedCode.phLength"
                            [style]="{width: '100%',borderTopLeftRadius: '0px',borderBottomLeftRadius: '0px'}"
                            (keypress)="restrictNumber($event, selectedCode.phLength)"
                            (ngModelChange)="onMobileChange()" [required]="model.isMandatory"
                            [class.disable-input-field]="model.disabled"
                            [disabled]="preview || (model.disabled ?? false) || !emailVerified"
                            [class.is-invalid]="touched && !model.isValid" (blur)="onBlur()" />
                    </p-inputGroup>
                </div>
                @if(((this.model.formName === ' Registration Form' || this.model.formName === 'Registration Form' ||
                this.model.formName === 'Registration Form Non-Technical') && enableMobile)
                && model.fieldName == 'Primary Mobile Number' && selectedCode.countryCodes[0] == '91') {
                <div class="verifyOtp">
                    <p-button styleClass="p-button-sm" class="verify-btn" *ngIf="!mobileVerified"
                        (click)="verifyMobile()" [ngStyle]="{'pointer-events': (enableMobileVerify ? 'auto' : 'none') }"
                        [ngClass]="model.disabled? 'disable-input_field' : ''" [disabled]="!enableMobileVerify">
                        <img alt="Verify" src="../../../assets/verify-symbol-white.png"
                            style="width: 18px; margin-right: 8px;" />
                        <span class="ml-2 font-bold">Verify </span>
                    </p-button>
                    @if (mobileVerified) {
                    <div class="verified">
                        <span>Verified</span>
                        <img src="../../../assets/verifed-symbol.png" alt="Verified"
                            style="width: 16px; margin-left: 8px; height: 16px;">
                    </div>
                    }
                </div>
                }
            </div>
            @if (!model.isValid && duplicateData.secondaryMobileSame) {
            <span class="error-message">Primary & Secondary Mobile cannot be same.</span>
            }
        </span>
        }

        @case("file") {
        <ng-container *ngTemplateOutlet="fileUploadTemplate; context: { isMulti: false }"></ng-container>
        }

        @case("multi-file") {
        <ng-container *ngTemplateOutlet="fileUploadTemplate; context: { isMulti: true }"></ng-container>
        }

        @case("multi-dropdown") {
        <span [class]="model.fieldId">
            <p-multiSelect [id]="model.fieldId" [options]="model.fieldOptions" [placeholder]="model.placeHolder"
                [class]="'field-' + model.fieldType" optionLabel="label" [(ngModel)]="model.answer"
                (ngModelChange)="onMultiDropdownChange()" [required]="model.isMandatory" #dropdownField="ngModel"
                [filter]="false" [showToggleAll]="false" [showHeader]="false" multiple
                [ngClass]="model.disabled? 'disable-input_field' : ''" [readonly]="model.readOnly || !emailVerified"
                [disabled]="preview || (model.disabled ?? false)" (blur)="onBlur()"
                [class.is-invalid]="touched && !model.isValid && model.isMandatory"
                #ms [overlayOptions]="{styleClass: 'overflow-auto'}"
                [panelStyle]="{
                    'min-width': ms.el.nativeElement.offsetWidth + 'px',
                    'max-width': ms.el.nativeElement.offsetWidth + 'px'
                }">
            </p-multiSelect>
            @if (touched && !model.isValid && model.isMandatory) {
            <span class="error-message">This field is required!</span>
            }
        </span>
        }

        @case ("textarea") {
        <span [class]="model.fieldId">
            <textarea pInputTextarea [(ngModel)]="model.answer[0]" [id]="model.fieldId" [autoResize]="false" [rows]="3"
                [ngClass]="model.disabled? 'disable-input_field' : ''" [readOnly]="model.readOnly"
                [disabled]="!emailVerified || (model.disabled ?? false)" (ngModelChange)="onTextareaChange()"
                [required]="model.isMandatory" (blur)="onBlur()"
                [class.is-invalid]="touched && !model.isValid && model.isMandatory">
                </textarea>
            @if(touched && !model.isValid) {
            <span class="error-message">Please enter valid data.</span>
            }
            @if(touched && !model.isValid && model.answer[0]?.length > 2000) {
            <span class="error-message">Please keep your answer within 2000 characters.</span>
            }
            @if (touched && !model.isValid && model.isMandatory) {
            <span class="error-message">
                This field is required!
            </span>
            }
        </span>
        }

        @case ("checkbox") {
        <span [class.grid-checkbox]="model.fieldOptions.length > 6" [class]="model.fieldType">
            @for (option of model.fieldOptions; track $index) {
            <div [class]="'field-' + model.fieldType">
                <p-checkbox [id]="option.value" [name]="model.fieldName" [value]="option.value"
                    [inputId]="model.fieldId + option.value" [(ngModel)]="model.answer"
                    (ngModelChange)="onCheckboxChange()" [required]="model.isMandatory"
                    [disabled]="!emailVerified || (model.disabled ?? false)">
                </p-checkbox>
                <label [for]="model.fieldId + option.value">{{ option.label }}</label>
            </div>
            }
        </span>
        }
        }
    </div>


    @if (model.fieldDescription && model.fieldDescription.length && model.fieldType != 'none' && model.fieldType !=
    'paragraph' && model.fieldValue !==
    "data_accuracy_declaration" && !(isPhotoField && photoCaptureMode && !preview)) {
    <ng-container *ngTemplateOutlet="description"></ng-container>
    }
</div>

<ng-template #description>
    <small class="field-description"
        [ngClass]="{'form-declaration': model.fieldName == 'Declaration & Consent' 
                || (model.displaySection == 'Diversity Questionnaire (Optional)' && model.fieldName == '' ) 
                || (model.displaySection == 'PWD Details' && model.fieldName == '' )}">{{model.fieldDescription}}</small>
</ng-template>

<ng-template #fileUploadTemplate let-isMulti="isMulti">
    <span [class]="model.fieldType">
        @if (showCaptureSwitcher) {
        <div class="photo-capture-switcher">
            <button type="button" class="photo-capture-tab" [class.active]="captureTab === 'camera'"
                (click)="setCaptureTab('camera')" [disabled]="uploadingFile || !emailVerified">
                <i class="pi pi-camera"></i> Live Capture
            </button>
            <button type="button" class="photo-capture-tab" [class.active]="captureTab === 'upload'"
                (click)="setCaptureTab('upload')" [disabled]="uploadingFile || !emailVerified">
                <i class="pi pi-upload"></i> Upload Photo
            </button>
        </div>
        }
        @if (showCameraInput) {
        @if (uploadingFile) {
        <div class="fileUpload-dropzone photo-camera-card">
            <p-progressSpinner [style]="{ height: '30px', width: '30px' }" strokeWidth="7" animationDuration="0.5s"></p-progressSpinner>
        </div>
        } @else if (!file.length) {
        <div class="fileUpload-dropzone photo-camera-card"
            role="button"
            [attr.tabindex]="(model.disabled ?? false) || !emailVerified || preview ? -1 : 0"
            [attr.aria-disabled]="(model.disabled ?? false) || !emailVerified || preview"
            [class.disable-input-field]="(model.disabled ?? false) || !emailVerified || preview"
            [class.is-invalid]="touched && !preview && !model.isValid"
            (click)="openCamera()"
            (keydown.enter)="openCamera()"
            (keydown.space)="openCamera(); $event.preventDefault()">
            <div class="dropzone-label">
                <img src="assets/icons-svg/camera.svg" class="photo-camera-icon" alt="Camera" />
                <p class="upload-text">
                    <span [style]="{ color: '#6944D6', 'text-decoration': 'underline' }">Open camera</span>
                    to take a live photo
                </p>
                <p class="format-text">Make sure your face is well-lit and centered</p>
            </div>
        </div>
        }
        <app-photo-capture [(visible)]="cameraDialogVisible" (captured)="onPhotoCaptured($event)"></app-photo-capture>
        }
        @if (!showCameraInput) {
        <div [id]="model.fieldId" [class.disable-input-field]="model.disabled"
            [disabled]="preview || (model.disabled ?? false) || !emailVerified" class="fileUpload-dropzone" ngx-dropzone
            [accept]="acceptedFileTypes" [multiple]="isMulti"
            (change)="model.fieldName === 'Please Upload Your Passport Size Photograph' ? onSelectfile($event, true) : onSelectfile($event)"
            [ngClass]="{ hidden: uploadingFile }" [class.is-invalid]="touched && !preview && !model.isValid">
            @if (!uploadingFile) {
            <ngx-dropzone-label>
                <div class="dropzone-label">
                    <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                    <p class="upload-text">
                        Drag & Drop your files here or
                        <span [style]="{ color: '#6944D6', 'text-decoration': 'underline' }">
                            Choose Files
                        </span>
                    </p>
                    <p class="format-text">
                        Recommended {{ acceptedFileFormats.join(", ") }} Only (Max File Size:
                        {{model.fileProperities.file_max_size}})
                    </p>
                </div>
            </ngx-dropzone-label>
            }
            @if (uploadingFile) {
            <p-progressSpinner [style]="{ height: '30px', width: '30px' }" strokeWidth="7" animationDuration="0.5s">
            </p-progressSpinner>
            }
        </div>
        }

        @if (isPhotoField && photoCaptureMode && !preview) {
        <p class="photo-proctoring-note">This photo is used for assessment identity verification and can't be changed
            later. Please add a clear, well-lit photo.</p>
        }

        @if (file.length) {
        @if (!isMulti) {
        <!-- Single file preview -->
        <div class="file-preview-section">
            <div class="file-preview-logo">
                <img src="assets/file-icon.png" />
            </div>
            <div class="file-preview-content">
                <h5 class="file-preview-content-name" [pTooltip]="file[0].name" tooltipPosition="top">{{ file[0].name }}</h5>
                @if (!editMode || file[0].size > 0) {
                <small class="file-preview-content-size">{{ file[0].size | fileSize }}</small>
                }
            </div>
            @if (editMode && file[0].size === 0) {
            <div class="view-file">
                <button pButton class="control-btn" (click)="viewFile()" title="View file">
                    <i class="pi pi-eye"></i>
                </button>
            </div>
            }
            <div class="remove-file">
                <button pButton class="control-btn" (click)="onRemovefile(file[0])">
                    <img src="assets/icons-svg/delete.svg" alt="Close" />
                </button>
            </div>
        </div>
        } @else {
        <!-- Multi-file preview -->
        @for (f of file; track $index) {
        <div class="file-preview-section">
            <div class="file-preview-logo">
                <img src="assets/file-icon.png" />
            </div>
            <div class="file-preview-content">
                <h5 class="file-preview-content-name" [pTooltip]="f.name" tooltipPosition="top">{{ f.name }}</h5>
                @if (!editMode || f.size > 0) {
                <small class="file-preview-content-size">{{ f.size | fileSize }}</small>
                }
            </div>
            @if (editMode && f.size === 0) {
            <div class="view-file">
                <button pButton class="control-btn" (click)="viewFileAtIndex($index)" title="View file">
                    <i class="pi pi-eye"></i>
                </button>
            </div>
            }
            <div class="remove-file">
                <button pButton class="control-btn" (click)="onRemovefile(f)">
                    <img src="assets/icons-svg/delete.svg" alt="Close" />
                </button>
            </div>
        </div>
        }
        }
        }
    </span>
</ng-template>